import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f60efbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "eventlist" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 mb-4 centertext" }, "Arrangementer", -1))
const _hoisted_3 = { class: "layout gutter--md" }
const _hoisted_4 = { class: "searchcontrols row align--center justify--space-around mb-4" }
const _hoisted_5 = { class: "md1 flex mobileReset" }
const _hoisted_6 = {
  class: "md5 sm8 xs12 flex",
  style: {"display":"flex"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_8 = { class: "md2 flex sm4 xs6" }
const _hoisted_9 = { class: "md3 flex sm8 xs6" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "va-table-responsive row"
}
const _hoisted_12 = { class: "flex md12 va-table va-table--clickable va-table--hoverable" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "mobileTable" }, "Sted", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "centertext" }, "Yderligere information", -1))
const _hoisted_15 = { class: "mobileTable" }
const _hoisted_16 = { class: "eventcapitalize" }
const _hoisted_17 = { class: "mobileTable" }
const _hoisted_18 = { class: "centertext" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Information")
const _hoisted_20 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_22 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_23 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_25 = { class: "selectPageSize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_divider = _resolveComponent("va-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_va_button, {
            class: "btn",
            color: "#b4003a",
            rounded: false,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.columnSort('reset')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_icon, {
                class: "reset",
                name: "autorenew"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_va_input, {
            modelValue: _ctx.eventSearchInputValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.eventSearchInputValue) = $event)),
            label: "Søg",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.findEvent()), ["enter"])),
            style: {"width":"85%"}
          }, {
            prependInner: _withCtx(() => [
              _createVNode(_component_va_icon, { name: "search" })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_button, {
            class: "btn ml-2",
            color: "#b4003a",
            rounded: false,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.findEvent()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_icon, { name: "search" }),
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_va_select, {
            label: "Type",
            modelValue: _ctx.filterByEventTypeValue,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterByEventTypeValue) = $event)),
            options: _ctx.filterByEventTypeOptions,
            bordered: ""
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_va_select, {
            label: "Arrangement status",
            modelValue: _ctx.filterByTimeValue,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterByTimeValue) = $event)),
            options: _ctx.filterByTimeOptions,
            bordered: ""
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    _createVNode(_component_va_divider),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.columnSort('eventname')))
                }, "Arrangementnavn"),
                _createElementVNode("th", {
                  class: "sorting mobileTable",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.columnSort('eventtype')))
                }, "Type"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.columnSort('dato')))
                }, "Afholdes"),
                _hoisted_13,
                _hoisted_14
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(event.event_titel), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(event.event_type_id.event_type_titel), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString((new Date(event.event_start)).toLocaleDateString('da-DK', {weekday: 'long', day: 'numeric', month: 'numeric', year: '2-digit'}) + ' - ' + (new Date(event.event_slut)).toLocaleDateString('da-DK', {weekday: 'long', day: 'numeric', month: 'numeric', year: '2-digit'})), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(event.event_sted), 1),
                  _createElementVNode("td", _hoisted_18, [
                    _createVNode(_component_va_button, {
                      color: "#b4003a",
                      onClick: ($event: any) => (_ctx.toEventInfo(event.id, event.event_titel, event.event_start))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_va_button, {
        icon: "first_page",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.jumpToPage(1)))
      }),
      _createVNode(_component_va_button, {
        icon: "keyboard_double_arrow_left",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.turnToNewPage(-5)))
      }),
      _createVNode(_component_va_button, {
        icon: "chevron_left",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.turnToNewPage(-1)))
      }),
      _hoisted_21,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentPage) = $event)),
        onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.currentPage]
      ]),
      (_ctx.totalNumberOfPages === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_22, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_23, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
      _createVNode(_component_va_button, {
        icon: "chevron_right",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.turnToNewPage(1)))
      }),
      _createVNode(_component_va_button, {
        icon: "keyboard_double_arrow_right",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.turnToNewPage(5)))
      }),
      _createVNode(_component_va_button, {
        icon: "last_page",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.jumpToPage(this.totalNumberOfPages)))
      }),
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_va_select, {
          class: "mr-2",
          modelValue: _ctx.pageSizeValueString,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
          options: _ctx.pageSizeOptions,
          bordered: ""
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}